module.exports = __webpack_public_path__ + "img/流体力学4_2.55e04532.jpg";